import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useParams,
} from "react-router-dom";
import FileUpload from "./FileUpload";
import axios from "axios";
import TableComponent from "./TableComponent";
import Productb from "./Productb";
import Productc from "./Productc";
import EditPage from "./EditPage";
import Login from "./Login";
import Dashboard from "./Dashboard";
import "./App.css";

function App() {
  const [items, setItems] = useState("");
  const API_URL = "https://uat.atlas.docauto.riverchain.xyz/api";

  const handleDelete = async (index) => {
    try {
      const response = await axios.delete(`${API_URL}/delete/${index}`);
      console.log("Item deleted successfully:", response.data);
    } catch (error) {
      console.error(
        "Error deleting item:",
        error.response?.data || error.message
      );
      alert("Failed to delete item.");
    }
  };

  const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
      const isAuthenticated = localStorage.getItem("isAuthenticated");
      if (isAuthenticated !== "true") {
        navigate("/"); // Redirect to login if not authenticated
      }
    }, [navigate]);

    return children;
  };

  // useEffect(() => {
  //   const fetchSitesB = async () => {
  //     try {
  //       const response = await fetch(`${API_URL}/sitesb`);
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       const data = await response.json();

  //       console.log("Fetched product B Data:", data?.isheet?.data?.item);
  //       setItemsB(data?.isheet?.data?.item);
  //       console.log("itemsB:", itemsB);
  //     } catch (error) {
  //       setError(error.message);
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchSitesB();
  // }, []);

  const handleEdit = (updatedItem) => {
    setItems(
      items.map((item) =>
        item.itemid === updatedItem.itemid ? updatedItem : item
      )
    );
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard items={items} />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Login />} />
        <Route
          path="/producta"
          element={<TableComponent handleDelete={handleDelete} />}
        />

        <Route path="/productb" element={<Productb />} />

        <Route path="/productc" element={<Productc />} />
        <Route
          path="/edit/:id"
          element={<EditPage items={items} handleEdit={handleEdit} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
